import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { deleteTransactionWithLedger, downloadExcel, getAllTransactions, updateTransaction } from '@/api/transactions';
import Pagination from '@/components/Pagination/index.vue';
import Enabled from '@/components/Enabled/index.vue';
import Inr from '@/components/Inr/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { searchDealers } from '@/api/dealers';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isExcludedToAccess, isSuperAdmin } from '@/common';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.loggedInAdmin = null;
    this.rejectFormVisible = false;
    this.branchListLoading = false;
    this.branchList = [];
    this.rowIndex = 0;
    this.dealerList = [];
    this.dealerListLoading = false;
    this.isAgent = false;
    this.dateRange = '';
    this.startDate = '';
    this.endDate = '';
    this.assignedBranches = [] || null;
    this.downloadLoading = false;
    this.formData = {
      id: null,
      status: 'failure',
      errorMessage: null,
      adminId: null
    };
    this.statusOptions = [{
      label: 'Success',
      key: 'success'
    }, {
      label: 'Pending',
      key: 'pending'
    }];
    this.listQuery = {
      dealerId: undefined,
      page: 1,
      limit: 10,
      createdTimestamp: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined,
      applyBranchIdFilter: true,
      status: 'success',
      // sort: "id,DESC",
      sort: 'createdTimestamp,DESC',
      filter: {
        dealerId: '$eq',
        createdTimestamp: 'between',
        branchId: '$in',
        status: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'Date Ascending',
      key: 'createdTimestamp,ASC'
    }, {
      label: 'Date Descending',
      key: 'createdTimestamp,DESC'
    }];
    this.statusColorMap = {
      pending: 'primary',
      success: 'success',
      failure: 'danger'
    };
    this.rules = {
      errorMessage: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  async activated() {
    try {
      this.loggedInAdmin = AdminModule;
      // check if logged in user is Agent/Admin
      if (this.loggedInAdmin.userType === 'Agent') {
        this.isAgent = true;
      }
      // Assign branchId using BranchAgentService
      // this.listQuery.branchId = await BranchAgentService.assignBranchId();
      this.assignedBranches = await BranchAgentService.assignBranchId();
      // Check if branchId is null and throw an error
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      // Fetch branches for non-super admin users
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      // Extract branchId from the URL
      const branchIdFromURL = this.$route.query.branchId;
      // If branchId exists in the URL, assign it
      if (branchIdFromURL) {
        this.listQuery.branchId = branchIdFromURL;
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.dateRange = {
          start: this.$route.query.startDate,
          end: this.$route.query.endDate
        };
        this.listQuery.createdTimestamp = [this.dateRange.start, this.dateRange.end].join(',');
      }
      await this.getList();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      this.listLoading = true;
      const data = await getAllTransactions(this.listQuery);
      this.list = data.allData;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  formatDate(timestamp) {
    if (!timestamp) return ''; // Handle null or undefined case
    const date = new Date(timestamp);
    // Format date as "DD-MM-YYYY"
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC'
    });
    return formattedDate;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        branchId: this.listQuery.branchId !== undefined ? this.listQuery.branchId : AdminModule.branchIds
      };
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {
      this.dealerListLoading = false;
    }
  }
  toggleRejectFormDialog(row, index = 0) {
    this.rejectFormVisible = true;
    this.formData.id = row.id;
    this.rowIndex = index;
  }
  validateForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  // getSummaries(param: any) {
  //   const { columns, data } = param;
  //   const sums: any = [];
  //   const totalGrandTotalRow: any = [];
  //   columns.forEach((column: any, index: number) => {
  //     // first column
  //     if (index === 0) {
  //       sums[index] = "Total Page Payments: ";
  //       return;
  //     }
  //     // index check ends
  //   }); // column loop ends
  //   // Return sums and total grand total row
  //   if (sums && sums.length) {
  //     sums[5] = sums[5].toFixed(2);
  //   }
  //   return [, , , , sums, , , ,]; // Return both the sums and total grand total row
  // }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      // For the first column, show a label
      if (index === 3) {
        sums[index] = 'Total Page Payments:';
        return;
      }
      // For other columns, calculate the total only for the "Amount" column
      const prop = column.property;
      if (prop === 'amount') {
        const total = data.reduce((sum, row) => {
          const value = Number(row[prop]); // Ensure numeric conversion
          return !isNaN(value) ? sum + value : sum;
        }, 0);
        sums[index] = total.toFixed(2); // Format to 2 decimal places
      } else {
        sums[index] = ''; // Empty for non-relevant columns
      }
    });
    return sums; // Return the array with summaries
  }
  async saveForm() {
    try {
      this.listLoading = true;
      this.rejectFormVisible = false;
      this.formData.adminId = this.loggedInAdmin.id;
      await updateTransaction(this.formData.id, this.formData);
      this.list[this.rowIndex].status = 'failure';
      this.$notify({
        title: 'Success',
        type: 'success',
        message: 'Transaction updated',
        duration: 2000
      });
      this.listLoading = false;
    } catch (error) {
      this.$message({
        message: error.toString(),
        type: 'error',
        showClose: true
      });
      this.listLoading = false;
    }
  }
  async approveForm(row, index = 0) {
    try {
      this.listLoading = true;
      await updateTransaction(row.id, {
        status: 'success'
      });
      this.list[index].status = 'success';
      this.$notify({
        title: 'Success',
        type: 'success',
        message: 'Transaction updated',
        duration: 2000
      });
      this.listLoading = false;
    } catch (error) {
      this.$message({
        message: error.toString(),
        type: 'error',
        showClose: true
      });
      this.listLoading = false;
    }
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.listQuery.createdTimestamp = [this.startDate, this.endDate].join(',');
      this.listQuery.startDate = this.startDate;
      this.listQuery.endDate = this.endDate;
    } else {
      this.listQuery.createdTimestamp = '';
      this.listQuery.page = 1;
    }
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  async deleteTransaction(params) {
    try {
      this.$confirm('Are you sure you want to delete this transaction?', 'Delete Transaction', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--success',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        await deleteTransactionWithLedger(params);
        this.$message({
          message: 'Transaction dleted successfully',
          type: 'success'
        });
        this.getList();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request cancelled'
        });
      });
    } catch (error) {
      this.$message.error('Error Deleting transaction');
    }
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const blob = await downloadExcel(this.listQuery);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'transactions.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'TransactionList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;